import { mobileLoginSelector, portalAction, PortalThunk, consumerSelector } from '../../'
import { AuthCheckCodeResponse, AuthResetRequest, CodeVerificationDirective, TwoFactorChallengeRequest, VerificationMethod } from '../../../model'

export const checkEmailEligibility: PortalThunk<string, { shouldDisableEmailOption: boolean }> = portalAction(
  'resetPassword/checkEmailEligibility',
  async (email, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/check-email-option-eligibility', { email })
  }
)

export const authResetCode: PortalThunk<{ sendBy: VerificationMethod }, CodeVerificationDirective> = portalAction(
  'resetPassword/sendCode',
  async (request, thunk) => {
    const { email, mobile } = consumerSelector(thunk.getState())
    const { isMobileLogin } = mobileLoginSelector(thunk.getState())

    if (isMobileLogin) {
      return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/mobile/code', {
        ...request,
        mobile,
      })
    } else {
      return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/code', {
        ...request,
        email,
      })
    }
  }
)

export const authCheckCode: PortalThunk<{ code: string }, AuthCheckCodeResponse> = portalAction('resetPassword/checkCode', async (request, thunk) => {
  const { email, mobile } = consumerSelector(thunk.getState())
  const { isMobileLogin } = mobileLoginSelector(thunk.getState())

  if (isMobileLogin) {
    return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/mobile/check-code', {
      ...request,
      mobile,
    })
  } else {
    return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/check-code', {
      ...request,
      email,
    })
  }
})

export const authReset: PortalThunk<AuthResetRequest, void> = portalAction('resetPassword/reset', async (request, thunk) => {
  const { isMobileLogin } = mobileLoginSelector(thunk.getState())
  const { email, mobile } = consumerSelector(thunk.getState())
  if (isMobileLogin) {
    return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/mobile', {
      ...request,
      mobile,
    })
  } else {
    return await thunk.extra.portalApi().post('/portal/consumers/auth/reset', {
      ...request,
      email,
    })
  }
})

export const authCheckChallenge: PortalThunk<TwoFactorChallengeRequest, void> = portalAction('resetPassword/checkChallenge', async (request, thunk) => {
  return await thunk.extra.portalApi().post('/portal/consumers/auth/reset/check-two-factor-challenges', request)
})
